import Reflux from 'reflux'
import ResizeActions from '../actions/ResizeActions'

var MainMenuToggleStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(ResizeActions.mainMenuToggle,'onMainMenuToggle');
       
    },
    onMainMenuToggle()
    {
        this.trigger();
    }
});

export default MainMenuToggleStore;


// WEBPACK FOOTER //
// ./src/stores/MainMenuToggleStore.js